/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useToast } from '@veneer/core';
import { Device, DeviceType } from '../types/devices';
import { OperationResult, OperationStatus } from '../types';
import { useDependencyManagerContext } from '../contexts/dependencyManager';

const usePostTelemetryToast = (
  postDeviceTelemetry: OperationResult,
  device: Device
): void => {
  const { addToast } = useToast();
  const { translate } = useDependencyManagerContext();

  useEffect(() => {
    if (postDeviceTelemetry.status === OperationStatus.COMPLETED) {
      addToast({
        id: `react-device-management-mfe-device-details-viewer-device-card-toast-post-telemetry-completed-${device.device_serial_nr}`,
        text: translate(
          'components.device-details-viewer.device-card.toasts.post-telemetry.success.text'
        ),
        subtitle:
          device.device_type === DeviceType.PERSONAL_COMPUTER
            ? translate(
                'components.device-details-viewer.device-card.toasts.post-telemetry.success.subtitle-pc'
              )
            : translate(
                'components.device-details-viewer.device-card.toasts.post-telemetry.success.subtitle',
                {
                  serialNumber: device.device_serial_nr,
                  deviceName: device.device_family
                }
              ),
        type: 'positive'
      });
    } else if (postDeviceTelemetry.status === OperationStatus.ERRORED) {
      addToast({
        id: `react-device-management-mfe-device-details-viewer-device-card-toast-post-telemetry-errored-${device.device_serial_nr}`,
        text: translate(
          'components.device-details-viewer.device-card.toasts.post-telemetry.failure.text'
        ),
        subtitle: translate(
          'components.device-details-viewer.device-card.toasts.post-telemetry.failure.subtitle',
          {
            serialNumber: device.device_serial_nr,
            deviceName: device.device_family
          }
        ),
        type: 'negative'
      });
    }
  }, [postDeviceTelemetry, device]);
};

export default usePostTelemetryToast;
